import {
  Gauge as MuiGauge,
  type GaugeProps as MuiGaugeProps,
} from "@mui/x-charts/Gauge";
import { useTheme } from "@mui/material/styles";

export type GaugeProps = MuiGaugeProps;

export function Gauge(props: GaugeProps) {
  const theme = useTheme();

  return (
    <MuiGauge
      {...props}
      sx={{
        "& .MuiGauge-valueArc": {
          fill: theme.palette.primary.main,
        },
        "& .MuiGauge-referenceArc": {
          fill: theme.palette.action.hover,
        },
        "& .MuiGauge-valueText": {
          fontFamily: theme.typography.fontFamily,
          fontSize: "1.25rem",
          fontWeight: theme.typography.fontWeightMedium,
          fill: theme.palette.text.primary,
        },
        ...((props.sx as object) ?? {}),
      }}
    />
  );
}
